<template>
  <div
    class="portfolio-pages-wrapper section-space--ptb_100 border-bottom gray-gradient"
  >
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div
            class="section-title-wrapper text-center section-space--mb_60 wow move-up"
          >
            <h2 class="section-title font-weight--bold mb-15">
              {{ $props.name }}
            </h2>
            <h6>
              {{ $props.summary }}
            </h6>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-8 col-md-10 wow move-up mb-30">
          <div
            class="portfolio-grid-caption text-center justify-content-center align-items-center"
          >
            <router-link to="" class="single-grid-caption">
              <div class="single-portfolio__thumbnail">
                <img class="img-fluid" :src="$props.image" :alt="$props.name" />
              </div>
            </router-link>
            <div class="post-info">
              <h5 class="post-title font-weight--bold">
                <router-link to="">
                  {{ $props.name }}
                </router-link>
              </h5>
              <br />
              <div class="post-categories">
                <p v-if="$props.description">
                  {{ $props.description }}
                </p>
                <p v-else>
                  {{ $props.summary }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-2 wow move-up mb-30">
          <div class="load-more-button text-center">
            <button class="ht-btn ht-btn-md ht-btn--outline loadMore">
              <router-link
                class="text-nowrap"
                :to="{
                  name: 'contact-us',
                  query: { subject: `Request for demo for ${$props.name}` },
                }"
              >
                Book A demo
              </router-link>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import products from "../data/products";

export default {
  props: {
    name: String,
    image: String,
    summary: String,
    description: String,
  },
  components: {},

  data() {
    return {
      products,
    };
  },
};
</script>
